import React from "react";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  InfoWindow,
  MarkerClusterer,
  Polyline,
} from "@react-google-maps/api";

import {
  myLocationMarker,
  locationOnMarker,
  defaultMarker,
  baseMarker,
} from "../Icons";
import { useAllContexts } from "../../../../hooks/useAllContexts";

const NewRouteMarkers = ({ positionMarker, openInfoWindow }) => {
  const { newRouteData } = useAllContexts();

  const renderNewRouteSteps = () => {
    return newRouteData?.get?.steps.map((step, id) => {
      return (
        <NewRouteMarker
          id={id}
          title={step.title}
          type="step"
          position={step.position}
        ></NewRouteMarker>
      );
    });
  };

  return (
    <div>
      <NewRouteMarker
        title={newRouteData?.get?.start?.address}
        type="start"
        position={newRouteData?.get?.start?.coordinates}
        positionMarker={{ get: positionMarker?.get, set: positionMarker?.set }}
        openInfoWindow={{ get: openInfoWindow?.get, set: openInfoWindow?.set }}
      >
        {openInfoWindow.get && positionMarker === "start" && (
          <InfoWindow>
            <p>{newRouteData?.get?.start?.address}</p>
          </InfoWindow>
        )}
      </NewRouteMarker>
      {renderNewRouteSteps()}
      <NewRouteMarker
        title={newRouteData?.get?.end?.address}
        type="end"
        position={newRouteData?.get?.end?.coordinates}
        positionMarker={positionMarker}
        openInfoWindow={openInfoWindow}
      >
        {openInfoWindow?.get && positionMarker?.get === "end" && (
          <InfoWindow>
            <p>{newRouteData?.get?.end?.address}</p>
          </InfoWindow>
        )}
      </NewRouteMarker>
    </div>
  );
};

export default NewRouteMarkers;

const NewRouteMarker = ({
  title,
  id = null,
  type,
  position,
  children,
  positionMarker = null,
  openInfoWindow = null,
}) => {
  return (
    <Marker
      key={`new_route_${type}_${id}`}
      noReDraw={true}
      title={title}
      position={
        type === "start" || type === "end"
          ? {
              lat: position?.latitude,
              lng: position?.longitude,
            }
          : position
      }
      icon={
        type === "start"
          ? myLocationMarker
          : type === "end"
          ? locationOnMarker
          : baseMarker
      }
      label={
        type === "step"
          ? {
              className: "step-style",
              text: `${id + 1}`,
              color: "#fff",
              fontSize: "16px",
            }
          : null
      }
      clickable
      onClick={() => {
        if (type === "start" || type === "end") {
          positionMarker.set(type);
          openInfoWindow.set(true);
        }
      }}
    >
      {children}
    </Marker>
  );
};
